<div class="container m-b-5">
  <div class="row animate fadeIn">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <input #input (keyup)="buscarServicios(input.value)" type="text" class="form-control"
            placeholder="Buscar servicios...">
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h3 class="card-title">Existen (<small>{{_basicosService.totalServicios}}</small>) servicios</h3>
          <div class="text-right">
            <button type="button" class="btn btn-md btn-rounded btn-success" [routerLink]="['/crearservicio','nuevo']"> Registrar Servicio</button>
          </div>

          <table class="table table-hover table-responsive-xl" style="width:100%; overflow-x: auto;">
            <thead>
              <tr>
                <th>Nombre del servicio</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let servicio of servicios">
                <td>{{servicio.nombre}}</td>
                <td>
                  <button [routerLink]="['/crearservicio', servicio._id]"  class="btn btn-success"><i
                    class="fa fa-save"></i></button>
                    <button (click)="borrarServicio(servicio)" style="background: #fc4b6c;" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>

          <button (click)="cambiarPaginacion(-6)" class="btn btn-circle btn-lg btn-success mr-2"><</button>
          <button (click)="cambiarPaginacion(6)" class="btn btn-circle btn-lg btn-success">></button>
</div>

